var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"id":_vm.id,"type":"text"},domProps:{"value":_vm.text},on:{"change":_vm.change,"input":function($event){return _vm.$emit('input', $event.target.value)},"keypress":function($event){return _vm.isNumber($event)},"keyup":function($event){return _vm.validateNumber($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }